import { render, staticRenderFns } from "./inc_person_step_1.vue?vue&type=template&id=ae84af7a&"
import script from "./inc_person_step_1.vue?vue&type=script&lang=js&"
export * from "./inc_person_step_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports